export const getAgencyConfigurationUrl = () => '/agency/configuration';
